// Which teamspace regions the Sales Dashboard is released for.
//
// Single source of truth for the gate rendered in two places: the Sidebar's
// "Sales" nav link and SalesDashboardPage itself (so a direct URL visit to
// /:teamspaceId/sales for a held-back region shows a clear message instead
// of silently working). Mirrors SALES_DASHBOARD_ENABLED_REGIONS in
// api/services/sales_service.py — keep the two in sync by hand; the two
// apps don't share a config source.
//
// This is a pure RELEASE gate, not a "does this region have sales rules
// built" one — a region can sit here only once its whole pipeline (billing-
// period bucketing, region-adaptive currency, tax/reimbursement exclusion,
// outstanding balance, invoice drill-down breakdown) is complete and
// verified. TH released 2026-09-22, once paid_in_month/cumulative_paid were
// verified against its live Bank data too (see sales_service.py's Phase
// status docstring). Add a region's name here (and to the backend's
// matching set) to release it — nothing else needs to change.
const SALES_DASHBOARD_ENABLED_REGIONS = ['JP', 'GVH', 'TH'];

export { SALES_DASHBOARD_ENABLED_REGIONS };
